/** Guide cadrage : 1 silhouette pointillée (tête + épaules). */
const CandidateSilhouetteGuide = ({ className = "" }) => (
  <div
    className={`absolute inset-0 pointer-events-none flex items-end justify-center px-[12%] pb-[3%] pt-[2%] opacity-55 ${className}`}
    aria-hidden="true"
    data-testid="silhouette-guide"
  >
    <div className="flex h-full w-full max-w-md items-end justify-center">
      <svg viewBox="0 0 120 180" className="h-full w-full" preserveAspectRatio="xMidYMid meet">
        <ellipse
          cx="60"
          cy="66"
          rx="30"
          ry="42"
          fill="none"
          stroke="rgba(255,255,255,0.92)"
          strokeWidth="3.2"
          strokeDasharray="1.8 10"
          strokeLinecap="round"
        />
        <path
          d="M8 172 C20 140 38 128 60 128 C82 128 100 140 112 172"
          fill="none"
          stroke="rgba(255,255,255,0.92)"
          strokeWidth="3.2"
          strokeDasharray="1.8 10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  </div>
);

export default CandidateSilhouetteGuide;
